import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { ProductCardItem } from '../../../common/types';
import { FormatPricePipe } from '../../pipes/format-price.pipe';
import { StarRatingComponent } from '../star-rating/star-rating.component';
import { RouterLink } from '@angular/router';
import { PictureComponent } from '../picture/picture.component';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'vsf-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        PictureComponent,
        NgFor,
        RouterLink,
        StarRatingComponent,
        FormatPricePipe,
    ],
})
export class ProductCardComponent {
    @Input() product: ProductCardItem;
    @Input() lazyLoadImg = false;
    @Output() productClick = new EventEmitter<void>();
}
